import app from '@/app.js';
import './i18n';
import './store';
import './router';
import './core/axios';
import { registerStaleChunkReload } from './core/staleChunkReload';
import './plugins/bugsnag';
import './plugins/day';
import './plugins/ability';
import './plugins/vueNotification';
import './plugins/vuetify';
import { initTracking } from './tracking';

import '@/assets/styles/main.scss';

registerStaleChunkReload();

// instantiate app
app.mount('#app');

// app.config.performance = true;

initTracking();

export default app;
